import React from "react";

import { Avatar, Tag } from "antd";
import { Divider } from "@mui/material";

import { KeyboardArrowDown } from "@mui/icons-material";
import Collapse from "@mui/material/Collapse";

import WithdrawModel from "./WithdrawModel";
import StakeModel from "./StakeModel";

import Arco from "../../asset/icons/Arco.png";
import Aptos from "../../asset/icons/Aptos.png";

export default function FarmCard() {
  const [open, setOpen] = React.useState(false);
  const [withdraw, setWithdraw] = React.useState(false);
  const [stake, setStake] = React.useState(false);
  return (
    <div className="flex flex-col items-center justify-between px-8 py-4 bg-white w-full shadow-md rounded-md space-y-4">
      <div className="flex flex-row items-center justify-between w-full space-x-6">
        <div className="flex flex-row items-center justify-center space-x-2">
          <Avatar.Group>
            <Avatar
              size="large"
              src={Aptos}
              style={{ border: "1px solid #00000040" }}
              className="bg-white border-2 border-solid border-text-black"
            />
            <Avatar
              size="large"
              src={Arco}
              style={{ border: "1px solid #00000040" }}
              className="bg-white border-2 border-solid border-text-black"
            />
          </Avatar.Group>
          <div className="flex flex-col space-y-2 items-start">
            <span className="text-xl text-text-dark-black font-semibold">
              APT/ARC
            </span>
            <Tag color="default" className="rounded-full px-4">
              Stable
            </Tag>
          </div>
        </div>
        <div className="flex-1 max-w-2xl flex flex-row items-center justify-center">
          <div className="flex flex-col items-center justify-center flex-1">
            <span className="text-lg text-text-black font-normal">APY</span>
            <span className="text-xl text-text-dark-black font-semibold">
              18%
            </span>
          </div>
          <Divider orientation="vertical" flexItem />
          <div className="flex flex-col items-center justify-center flex-1">
            <span className="text-lg text-text-black font-normal">TVL</span>
            <span className="text-xl text-text-dark-black font-semibold">
              $5,432
            </span>
          </div>
          <Divider orientation="vertical" flexItem />
          <div className="flex flex-col items-center justify-center flex-1">
            <span className="text-lg text-text-black font-normal">
              Your Stake
            </span>
            <span className="text-xl text-text-dark-black font-semibold">
              $0
            </span>
          </div>
          <Divider orientation="vertical" flexItem />
          <div className="flex flex-col items-center justify-center flex-1">
            <span className="text-lg text-text-black font-normal">
              Daily Return
            </span>
            <span className="text-xl text-text-dark-black font-semibold">
              $0
            </span>
          </div>
        </div>
        <div
          className="flex flex-row items-center justify-center rounded-full w-10 h-10 bg-text-blur bg-opacity-10 cursor-pointer"
          onClick={() => setOpen((open) => !open)}
        >
          <KeyboardArrowDown style={{ color: "#5361DC", fontSize: 24 }} />
        </div>
      </div>
      <Collapse in={open} timeout="auto" className="w-full">
        <Divider className="w-full mt-4" />
        <div className="flex flex-row items-center justify-between w-full space-x-32 mt-4">
          <div className="flex flex-col items-center justify-center space-y-1 max-w-[14rem] flex-1">
            <div className="w-full flex flex-row items-center justify-between">
              <span className="text-lg text-text-black font-normal">
                Total Staked
              </span>
              <span className="text-lg text-text-dark-black font-semibold">
                4,545,531
              </span>
            </div>
            <div className="w-full flex flex-row items-center justify-between">
              <span className="text-lg text-text-black font-normal">
                LP Price
              </span>
              <span className="text-lg text-text-dark-black font-semibold">
                $0.44
              </span>
            </div>
            <div className="w-full flex flex-row items-center justify-between">
              <span className="text-lg text-text-black font-normal">
                APR Boost
              </span>
              <span className="text-lg text-text-dark-black font-semibold">
                x1.4
              </span>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center space-y-1 max-w-[14rem] flex-1">
            <div className="w-full flex flex-row items-center justify-between">
              <span className="text-lg text-text-black font-normal">
                Total Staked
              </span>
              <span className="text-lg text-text-dark-black font-semibold">
                4,545,531
              </span>
            </div>
            <div className="w-full flex flex-row items-center justify-between">
              <span className="text-lg text-text-black font-normal">
                LP Price
              </span>
              <span className="text-lg text-text-dark-black font-semibold">
                $0.44
              </span>
            </div>
            <div className="w-full flex flex-row items-center justify-between">
              <span className="text-lg text-text-black font-normal">
                APR Boost
              </span>
              <span className="text-lg text-text-dark-black font-semibold">
                x1.4
              </span>
            </div>
          </div>
          <div className="flex-1 flex flex-row items-center justify-center space-x-4">
            <span className="text-base text-text-blur font-bold cursor-pointer">
              View on FTMScan
            </span>
            <span
              className="text-base text-text-blur font-bold cursor-pointer px-4 py-2 rounded-full bg-text-blur bg-opacity-10"
              onClick={() => setWithdraw(true)}
            >
              Withdraw
            </span>
            <span
              className="text-base text-text-blur font-bold cursor-pointer px-4 py-2 rounded-full bg-text-blur bg-opacity-10"
              onClick={() => setStake(true)}
            >
              Stake
            </span>
          </div>
        </div>
      </Collapse>
      <WithdrawModel withdraw={withdraw} setWithdraw={setWithdraw} />
      <StakeModel stake={stake} setStake={setStake} />
    </div>
  );
}
